module.exports = __webpack_public_path__ + "img/carsmall.2635bc86.png";